module.exports = __webpack_public_path__ + "static/frito-3d5fe821be523db6bec00daa20070f5f.svg";